import { sliderFace } from "@/components/input/custom/pain-slider/sliderFace";
import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface PainSliderEntryValueProps
	extends Omit<BaseEntryValueProps, "value"> {
	value: number | null;
}

export function PainSliderEntryValue({
	value,
	inputLabel,
	size,
	className,
	...props
}: PainSliderEntryValueProps) {
	const numericValue = value !== null ? Number(value) : 0;
	const { icon, message } = sliderFace(numericValue);

	return (
		<BaseEntryValue
			inputLabel={inputLabel}
			className={cn("", className)}
			size={size}
			{...props}
		>
			<div className="flex flex-col gap-2">
				<div className="flex items-center gap-2">
					<div
						className={cn(
							"flex items-center justify-center",
							size === "sm"
								? "w-6 h-6"
								: size === "lg"
									? "w-12 h-12"
									: "w-10 h-10",
						)}
					>
						{icon}
					</div>
					<div>
						<p
							className={cn(
								"dark:text-slate-200",
								size === "sm"
									? "text-sm"
									: size === "lg"
										? "text-xl"
										: "text-base",
							)}
						>
							{String(value)}/10
						</p>
						<p
							className={cn(
								"text-slate-500 dark:text-slate-400",
								size === "sm"
									? "text-xs"
									: size === "lg"
										? "text-sm"
										: "text-sm",
							)}
						>
							{message}
						</p>
					</div>
				</div>
			</div>
		</BaseEntryValue>
	);
}
